<!-- eslint-disable -->
<template>
  <div class="template-editor">
    <div class="template-container" ref="templateContainer">
      <img
          src="/scan1.jpg"
          alt="PDF Template"
          class="template-image"
          @load="initTemplate"
      >

      <div
          v-for="(field, name) in fields"
          :key="name"
          class="form-field"
          :style="{
          left: field.x * pixelPerMm + 'px',
          top: field.y * pixelPerMm + 'px',
          opacity: field.value ? 1 : 0.5,
         fontSize: field.fontSize + 'px'
        }"
          @mousedown.prevent="startDrag(name, $event)"
      >
        {{ field.value || name }}
        <!--        <div class="coordinates">{{ field.x }}mm, {{ field.y }}mm</div>-->
      </div>
    </div>

    <form @submit.prevent="createData" class="input-form">
      <div class="button-group">
        <div @click="saveCoordinates" class="btn btn-primary">Сохранить координаты</div>
        <div @click="resetCoordinates" class="btn btn-secondary">Сбросить все</div>
      </div>
      <div class="form-group" v-for="(field, name) in fields" :key="'input-'+name">
        <label>{{ name }}</label>
        <input
            type="text"
            v-model="field.value"
            class="form-control"
            @input="updateField(name)"
        >
        <input
            type="number"
            v-model.number="field.fontSize"
            class="form-control"
            min="8"
            max="72"
            @input="updateField(name)"
        >
      </div>

      <button type="submit" class="btn btn-primary">Сгенерировать PDF</button>
    </form>

  </div>
</template>


<script>
import {createLegal, saveCoordinates, loadCoordinates} from '@/api/legal';

import {parseTime} from '@/utils';
import FlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css'; // Import Flatpickr styles
import 'flatpickr/dist/l10n/ru.js';
import {useAuthStore} from "@/stores/auth";

const calendarTypeOptions = [
  {key: 'US', display_name: 'USA'},
];

const calendarTypeKeyValue = calendarTypeOptions.reduce((acc, cur) => {
  acc[cur.key] = cur.display_name;
  return acc;
}, {});

export default {
  name: 'candidatesEdit',
  components: {
    FlatPickr,
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'info',
        deleted: 'danger',
      };
      return statusMap[status];
    },
    typeFilter(type) {
      return calendarTypeKeyValue[type];
    },
  },
  data() {
    return {
      fields: {
        номер: {x: 83, y: 28, value: '', fontSize: 12},
        год: {x: 109, y: 28, value: '', fontSize: 12},
        дата: {x: 98, y: 35, value: '', fontSize: 12},
        год2: {x: 134, y: 35, value: '', fontSize: 12},
        имя: {x: 48, y: 60, value: '', fontSize: 12},
        песель: {x: 48, y: 65, value: '', fontSize: 12},
        адрес: {x: 48, y: 71, value: '', fontSize: 12},
        место_работы: {x: 9, y: 80, value: '', fontSize: 12},
        должность: {x: 9, y: 89, value: '', fontSize: 12},
        термин_подачи: {x: 66, y: 132, value: '', fontSize: 12},
        год3: {x: 135, y: 132, value: '', fontSize: 12},
        дата_подписи: {x: 23, y: 143, value: '', fontSize: 12},
        год_подписи: {x: 46, y: 143, value: '', fontSize: 12},
      },
      templateRect: null,
      pixelPerMm: 1, // Співвідношення пікселів до мм
      isDragging: null,


      userFirms: [],
      firmData: {},
      authStore: useAuthStore(),
      currentUserId: null,
      selectedFirm: null,
      isEditPage: false,
      candidateId: null,
      isOpen: false,
      isOpen2: false,
      vacancyDetail: null,
      isOffcanvasVisible: false,
      fromVacancy: false,
      peselOption: 'no',
      peselOption2: 'no',
      userRole: '',
      position: null,
      checkedFields: ['name', 'phone', 'passport', 'pesel'],
      tableKey: 0,
      vacancies: [],
      recruiters: [],
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        isBlackList: 0,
        search: '',
        sort: '+id',
        status: null,
        year: null,
        month: null
      },
      months: [
        {label: 'Январь'},
        {label: 'Февраль'},
        {label: 'Март'},
        {label: 'Апрель'},
        {label: 'Май'},
        {label: 'Июнь'},
        {label: 'Июль'},
        {label: 'Август'},
        {label: 'Сентябрь'},
        {label: 'Октябрь'},
        {label: 'Ноябрь'},
        {label: 'Декабрь'},
      ],
      calendarTypeOptions,
      sortOptions: [{label: 'ID Ascending', key: '+id'}, {label: 'ID Descending', key: '-id'}],
      statusOptions: ['published', 'draft', 'deleted'],
      showReviewer: false,
      formattedVacancies: [],
      temp: {
        name: '',
        surname: '',
        birth: '',
        passport: '',
        email: '',
        phone: '',
        work_address: '',
        position: '',
        rate: 0,
        firma: ''
      },
      temp2: {
        name: '',
        vacancyCandidateId: null,
        gender: 3,
        is_pair: 1,
        pesel: '',
        recruiterId: '',
        birth: ''
      },
      flatpickrConfig: {
        dateFormat: 'd-m-Y', // Format the date as YYYY-MM-DD
        locale: 'ru', // Set locale to Russian
        allowInput: true, // Allow manual input
        altInput: true, // Show a human-readable format in the input
        altFormat: 'd-m-Y', // Human-readable format (e.g., 1 января 2023)
        static: false, // Show the calendar inline (optional)
      },
      dialogFormVisible: false,
      dialogFieldsVisible: false,
      dialogBlackListVisible: false,
      dialogStatus: '',
      textMap: {
        update: 'Edit',
        create: 'Create',
      },
      dialogPvVisible: false,
      pvData: [],
      rules: this.setRules(),
      downloadLoading: false,
    };
  },
  watch: {},
  methods: {
    async saveCoordinates() {
      const coordinatesToSave = {};
      Object.keys(this.fields).forEach(key => {
        coordinatesToSave[key] = {
          x: this.fields[key].x,
          y: this.fields[key].y,
          fontSize: this.fields[key].fontSize
        };
      });

      saveCoordinates({coordinates: coordinatesToSave, templateType: 1})
          .then(() => {
            alert('сохранено');
          })
          .catch(error => {
            console.error('Error saving coordinates:', error);

          });
    },

    resetCoordinates() {
      this.fields = {
        номер: {x: 83, y: 28, value: '', fontSize: 12},
        год: {x: 109, y: 28, value: '', fontSize: 12},
        дата: {x: 98, y: 35, value: '', fontSize: 12},
        год2: {x: 134, y: 35, value: '', fontSize: 12},
        имя: {x: 48, y: 60, value: '', fontSize: 12},
        песель: {x: 48, y: 65, value: '', fontSize: 12},
        адрес: {x: 48, y: 71, value: '', fontSize: 12},
        место_работы: {x: 9, y: 80, value: '', fontSize: 12},
        должность: {x: 9, y: 89, value: '', fontSize: 12},
        термин_подачи: {x: 66, y: 132, value: '', fontSize: 12},
        год3: {x: 135, y: 132, value: '', fontSize: 12},
        дата_подписи: {x: 23, y: 143, value: '', fontSize: 12},
        год_подписи: {x: 46, y: 143, value: '', fontSize: 12},
      };
    },

    async loadCoordinates() {
      loadCoordinates()
          .then((response) => {
            if (response && Object.keys(response).length > 0) {
              // Create a new fields object with updated positions but empty values
              const updatedFields = {};

              Object.keys(this.fields).forEach(key => {
                updatedFields[key] = {
                  x: response[key]?.x || this.fields[key].x,
                  y: response[key]?.y || this.fields[key].y,
                  fontSize: response[key]?.fontSize || this.fields[key].fontSize,
                  value: ''
                };
              });

              this.fields = updatedFields;
            }
          })
          .catch(error => {
            console.error('Error loading coordinates:', error);
          });
    },
    handleRightClick(event) {
      event.preventDefault(); // Disable the default context menu

      // Get the cell data
      const cellData = event.target.innerText;

      // Call your method with cell data
      this.openCustomContextMenu(cellData, event);

      // Add an event listener to the document to reset filters on click outside
      document.addEventListener('click', this.handleDocumentClick);
    },
    openCustomContextMenu(cellData, event) {
      // Your custom context menu logic
      console.log('Right-clicked cell data:', cellData);
      this.listQuery.search = cellData;
      this.handleFilter();
    },
    handleDocumentClick(event) {
      const tableElement = this.$refs.candidates1.$el; // Access the DOM element of the table
      // Check if the click was outside the table
      if (tableElement && !tableElement.contains(event.target)) {
        this.resetFilters();
        document.removeEventListener('click', this.handleDocumentClick);
      }

      const tableElement2 = this.$refs.candidates2.$el; // Access the DOM element of the table
      // Check if the click was outside the table
      if (tableElement2 && !tableElement2.contains(event.target)) {
        this.resetFilters();
        document.removeEventListener('click', this.handleDocumentClick);
      }

      const tableElement3 = this.$refs.candidates3.$el; // Access the DOM element of the table
      // Check if the click was outside the table
      if (tableElement3 && !tableElement3.contains(event.target)) {
        this.resetFilters();
        document.removeEventListener('click', this.handleDocumentClick);
      }
    },
    resetFilters() {
      this.listQuery.search = '';
      this.handleFilter();
      // Your logic to reset filters
      console.log('Filters reset');
    },
    arrivalLabel() {
      return 'Работает от';
      // return this.listQuery.status === 3 ? 'Работает от' : 'Дата приезда';
    },
    formatDate(date) {
      if (!date) return '';
      const [year, month, day] = date.split('-');
      return `${day}-${month}-${year}`;
    },
    parseStatusFromUrl() {
      const path = this.$route.path;
      const regex = /status(\d+)/;
      const match = path.match(regex);
      if (match && match[1]) {
        this.listQuery.status = match[1];
      } else {
        this.listQuery.status = this.$route.query.status || null;
      }
      if (this.listQuery.status) {
        this.getList()
      }
    },
    checkBlackList() {
      const fullUrl = window.location.href;
      this.listQuery.isBlackList = fullUrl.includes('black-list') ? 1 : 0;
    },
    // isArrivalDaterequired-() {
    //   return this.temp.status === 'Приезд';
    // },
    setRules() {
      return {
        name: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        phone: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        passport: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        /*  pesel: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],*/
        comment: [{required: false, message: 'Обязательное поле', trigger: 'blur'}],
        gender: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
      };
    },
    async getList() {
      const path = this.$route.path;
      if (path.includes('/edit/')) {
        const id = path.split('/edit/')[1];

        const data = await fetchCandidate(id);
        this.list = data.candidates.items;
        this.vacancies = data.vacancies;
        this.userRole = data.userRole;
        this.formatVacancies(this.vacancies);
        this.recruiters = data.recruiters;


        this.isEditPage = true;
        this.candidateId = id;
        const foundCandidate = this.list.find(candidate => candidate.id === Number(this.candidateId));
        if (foundCandidate) {
          console.log('Found candidate:', foundCandidate);
          this.temp = JSON.parse(JSON.stringify(foundCandidate));
        } else {
          console.warn(`Candidate with ID ${this.candidateId} not found in the list.`);
        }
      } else {
        const data = await fetchList(this.listQuery);
        this.list = data.candidates.items;
        this.vacancies = data.vacancies;
        this.userRole = data.userRole;
        this.formatVacancies(this.vacancies);
        this.recruiters = data.recruiters;
        this.isEditPage = false;
        console.log('Create mode');
      }
    },
    formatVacancies(data) {
      let options = [];
      this.vacancies.forEach(vacancy => {
        if (vacancy.is_active === 1) {
          vacancy.vacancy_candidates.forEach(candidate => {
            options.push({
              label: `${vacancy.title}/${candidate.position}`,
              value: candidate.id
            });
          });
        }
      });
      this.formattedVacancies = options;
    },
    handleFilter() {
      //alert(this.listQuery.year);
      const searchQuery = this.listQuery.search?.trim(); // Ensure search is trimmed and exists

      if (!searchQuery) {  // If searchQuery is null, undefined, or empty, reset the filter
        this.listQuery.search = '';
        this.listQuery.page = 1;
        this.getList();  // Return full list
      } else if (searchQuery.length === 1) {
        // Do nothing if length is 1
        return;
      } else if (searchQuery.length > 1) {  // If length > 1, search and save
        this.listQuery.page = 1;
        this.getList();
      }
    },
    handleFilterStatus(status) {
      this.listQuery.status = status;
      this.getList();
    },
    handleModifyStatus(row, status) {

      row.status = status;
    },
    sortChange(data) {
      const {prop, order} = data;
      this.sortBy(prop, order);
    },
    sortBy(prop, order) {
      if (order === 'ascending') {
        this.listQuery.sort = '+' + prop;
      } else {
        this.listQuery.sort = '-' + prop;
      }
      this.handleFilter();
    },
    resetTemp() {
      this.temp = {};
    },
    handleCreate(fromVacancy = false) {
      if (!fromVacancy) {
        this.resetTemp();
      }
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    handleExport() {

    },
    handleBlackList() {
      this.dialogBlackListVisible = true;
    },

    //print
    initTemplate() {
      const img = this.$refs.templateContainer.querySelector('img')
      const a5WidthMm = 148 // Ширина A5 в мм
      const a5HeightMm = 210 // Висота A5 в мм

      // Отримуємо реальні розміри зображення на екрані
      const displayedWidth = img.offsetWidth
      const displayedHeight = img.offsetHeight

      // Розраховуємо співвідношення пікселів до мм
      this.pixelPerMm = displayedWidth / a5WidthMm

      console.log('Pixel per mm:', this.pixelPerMm)
    },

    startDrag(fieldName, e) {
      this.isDragging = fieldName
      const img = this.$refs.templateContainer.querySelector('img')
      const rect = img.getBoundingClientRect()

      const moveHandler = (e) => {
        if (!this.isDragging) return

        // Отримуємо координати відносно зображення
        const x = (e.clientX - rect.left) / this.pixelPerMm
        const y = (e.clientY - rect.top) / this.pixelPerMm

        // Обмежуємо координати розмірами A5
        this.fields[fieldName].x = Math.max(0, Math.min(x, 148))
        this.fields[fieldName].y = Math.max(0, Math.min(y, 210))
      }

      const upHandler = () => {
        document.removeEventListener('mousemove', moveHandler)
        document.removeEventListener('mouseup', upHandler)
        this.isDragging = null
      }

      document.addEventListener('mousemove', moveHandler)
      document.addEventListener('mouseup', upHandler)
    },

    updateField(name) {
      this.$nextTick(() => {
        //this.fields[name].value = this.fields[name].value.trim()
      })
    },

    createData() {
      const formData = {
        coordinates: {},
        values: {},
        fontSizes: {}
      }

      // Конвертуємо позиції в мм для PDF
      Object.keys(this.fields).forEach(name => {
        formData.coordinates[name] = {
          x: this.fields[name].x,
          y: this.fields[name].y
        }
        formData.values[name] = this.fields[name].value
        formData.fontSizes[name] = this.fields[name].fontSize
      })

      createLegal(formData)
          .then((response) => {
            console.log(response);
            if (response.success) {
              //alert(response.download_url);
              axios.get(response.download_url, {
                responseType: 'blob'
              }).then(downloadResponse => {
                const blob = new Blob([downloadResponse.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = response.file_url.split('/').pop();
                link.click();
                setTimeout(() => {
                  window.URL.revokeObjectURL(url);
                }, 100);
              });
            }
          })
          .catch(error => {
            console.error('Error:', error);
          });
    },

    createData_() {
      // Validate required fields
      /*    if (!this.temp.firma) {
            alert('Пожалуйста, выберите предприятие');
          } else if (!this.temp.name) {
            alert('Пожалуйста, введите имя');
          } else if (!this.temp.surname) {
            alert('Пожалуйста, введите фамилию');
          } else if (!this.temp.birth) {
            alert('Пожалуйста, укажите дату рождения');
          } else if (!this.temp.passport) {
            alert('Пожалуйста, введите паспортные данные');
          } else if (!this.temp.work_address) {
            alert('Пожалуйста, введите адрес');
          } else if (!this.temp.position) {
            alert('Пожалуйста, укажите должность');
          } else if (!this.temp.rate) {
            alert('Пожалуйста, укажите ставку');
          }*/// else {


      createLegal(this.temp).then((response) => {
        // this.$router.push('/legal/index');
      });
      //}
    },
    handleUpdate(row) {
      this.temp = Object.assign({}, row); // copy obj
      this.dialogStatus = 'update';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    updateData() {
      /*     this.$refs['dataForm'].validate((valid) => {
             if (valid) {*/
      const tempData = Object.assign({}, this.temp);
      updateCandidate(tempData).then(() => {
        for (const v of this.list) {
          if (v.id === this.temp.id) {
            const index = this.list.indexOf(v);
            this.list.splice(index, 1, this.temp);
            break;
          }
        }
        this.dialogFormVisible = false;
        /*    this.$notify({
              title: 'Успешно',
              message: 'Данные успешно изменены',
              type: 'success',
              duration: 2000,
            });*/
        let redirect = '1';
        if (this.temp.status === 'Работает') {
          redirect = '3';
        } else if (this.temp.status === 'Не работает') {
          redirect = '4';
        }
        //window.location.href = '/#/candidates/status' + redirect;
        //window.location.href = '/#/candidates/status3';
      });

      this.$router.push('/legal/index');
      /*  }
      });*/
    },
    handleDelete(row) {
      if (confirm('подтвердить удаление')) {
        deleteCandidate(row).then(() => {
          this.$notify({
            title: 'Успешно',
            message: 'Удалено',
            type: 'success',
            duration: 2000,
          });
          const index = this.list.indexOf(row);
          this.list.splice(index, 1);
        });
      }
    },
    handleFetchPv(pv) {
      fetchPv(pv).then(response => {
        this.pvData = response.data.pvData;
        this.dialogPvVisible = true;
      });
    },
    handleUpload() {
      this.$refs['excel-upload-input'].click();
    },
    handleClick(e) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = e => {
        this.temp.image = e.target.result;
      };
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j]);
        } else {
          return v[j];
        }
      }));
    },
    handleDownload() {
      /*      this.downloadLoading = true;
            import('@/vendor/Export2Excel').then(excel => {
              const tHeader = ['№', 'Вакансия', 'Цена', 'Статус', 'Дата', 'Кандидат', 'Телефон', 'Рекрутер', 'Координатор', 'Комментарий'];
              const filterVal = ['number', 'project', 'rate', 'status', 'arrivalDate', 'name', 'phone', 'coordinator', 'recruiter', ''];
              const list = this.list;
              const data = this.formatJson(filterVal, list);
              excel.export_json_to_excel({
                header: tHeader,
                data,
                filename: 'candidates',
                autoWidth: this.autoWidth,
                bookType: this.bookType,
              });
              this.downloadLoading = false;
            });*/
    },
  }
  ,
  computed: {
    checkIsDisabled() {
      return (
          this.listQuery.isBlackList === 1 &&
          !['grand_admin', 'admin', 'manager'].includes(this.userRole)
      );
    },
  },
  async mounted() {
    this.currentUserId = this.authStore.user.id;
    const firma = this.authStore.user.firma;
    this.userFirms = firma ? firma.split(',') : [];
    this.loadCoordinates();
  },
}
;
</script>

<style scoped>

.form-control {
  /* height: 40px !important;*/
  padding: 8px 16px !important;
}

.modal {
  background-color: rgba(0, 0, 0, 0.5);
}

.calendar {
  border: 1px solid #ddd;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  max-width: 900px;
  padding: 10px;
  box-sizing: border-box;
}

.header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  background-color: #f0f0f0;
  font-weight: bold;
}

.day {
  padding: 10px;
  text-align: center;
}

.month-controls {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}

.grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-auto-rows: minmax(100px, auto);
  gap: 1px;
}

.cell {
  border: 1px solid #ddd;
  background-color: #fff;
  text-align: center;
  padding: 5px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.cell.empty {
  background-color: #f9f9f9;
}

.date {
  font-size: 1.2em;
  margin-bottom: 5px;
}

.time-inputs {
  display: flex;
  justify-content: space-between;
  gap: 2px;
}

input[type="time"] {
  padding: 2px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.footer {
  margin-top: 10px;
  text-align: center;
}

.footer-text {
  margin-bottom: 10px;
}

.footer-button {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.footer-button button {
  padding: 5px 15px;
  font-size: 16px;
  cursor: pointer;
}

@media (max-width: 600px) {
  .calendar {
    width: 100%;
  }
}

.btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #000;
  opacity: 0.5;
  transition: opacity 0.2s ease;
}

.btn-close:hover {
  opacity: 1;
}


/*
* print
*/
.template-editor {
  display: flex;
  gap: 2rem;
  padding: 20px;
}

.template-container {
  position: relative;
  margin: 20px;
}

.template-image {
  width: 100%;
  display: block;
}

.form-field {
  position: absolute;
  top: 0;
  left: 0;
  cursor: move;
  font-family: Arial, sans-serif;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  background: rgba(255, 255, 255, 0.9);
  padding: 2px 5px;
  border: 1px dashed #666;
  white-space: nowrap;
  transition: transform 0.05s linear; /* Додано плавність */
  will-change: transform; /* Оптимізація анімації */
}

.form-field:hover {
  border-color: #2196F3;
  z-index: 10;
}

.input-form {
  flex: 0 0 300px;
  padding: 20px;
  background: #f5f5f5;
  border-radius: 4px;
}

.form-group {
  margin-bottom: 1rem;
}

.form-control {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.button-group {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 0 20px;
}

.btn {
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  border: none;
}

.btn-primary {
  background-color: #409eff;
  color: white;
}

.btn-secondary {
  background-color: #909399;
  color: white;
}

.btn:hover {
  opacity: 0.8;
}

</style>
<!-- eslint-enable -->
